import React from 'react';

import { getCityLabelByName } from '@data/cities';
import { warehouseStrings } from '@data/warehouse';
import { Warehouse } from '@models/Warehouse';
import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  warehouseDisplayContainer: {
    ...common.middleText,
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: '30px',
    '& *[role="head"]': {
      ...common.textGray500,
    },
  },
}));

export interface WarehouseDisplayProps {
  item: Warehouse;
}

export const WarehouseDisplay: React.FC<WarehouseDisplayProps> = ({ item }) => {
  const classes = { ...useCommonStyles(), ...useStyles() };

  return (
    <div className={classes.warehouseDisplayContainer}>
      <div style={{ gridColumn: 'span 2', marginBottom: 8 }}>
        <b>{item.name}</b>

        {' - '}
        {item.name_en}
      </div>

      <div role="head">{warehouseStrings.city}</div>

      <div>{getCityLabelByName(item.city)}</div>

      <div role="head">{warehouseStrings.zipcode}</div>

      <div>{item.zipcode}</div>

      <div role="head">{warehouseStrings.address1}</div>

      <div>{item.address1}</div>

      <div role="head">{warehouseStrings.address2}</div>

      <div>{item.address2}</div>

      <div role="head">{warehouseStrings.principalName}</div>

      <div>{item.principal_name}</div>

      <div role="head">{warehouseStrings.phone}</div>

      <div>{item.phone}</div>

      <div role="head">{warehouseStrings.memo}</div>

      <div>{item.memo || '-'}</div>
    </div>
  );
};
